import React, { Component } from "react";
import { connect } from "react-redux";
import ToCollegeToolConditionSubject from "../ToCollegeToolCondition/components/ToCollegeToolConditionSubject";
import ToCollegeToolConditionScore from "../ToCollegeToolCondition/components/ToCollegeToolConditionScore";
import ToCollegeToolConditionConfirm from "../ToCollegeToolCondition/components/ToCollegeToolConditionConfirm";
import { actions as toCollegeToolActions } from "../../../redux/modules/tocollagetool";
import Line from "../../../components/Line";
import ErrorTip from "../../../components/ErrorTip";
import { post, get } from "../../../utils/request";
import { jumpUrl } from "../../../utils/tool.js";
let toCollegeSiv;
class ToCollegeToolCondition extends Component {
  componentWillMount() {
    this.requestShareConfig();
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    this.requestUserCondition();
    this.requestIsBuy();
    document.title = "浙考之家-每日高升-志愿智能助手";
  }
  render() {
    const {
      subjectCondition,
      uiState,
      wholeSubject,
      subjectScore,
      totalScore,
      times,
      release,
    } = this.props;
    return (
      <div>
        <Line></Line>
        <ToCollegeToolConditionSubject
          subjectCondition={subjectCondition}
          handleChooseSubject={this.handleChooseSubject}
        ></ToCollegeToolConditionSubject>
        <Line></Line>
        <ToCollegeToolConditionScore
          subjectCondition={subjectCondition}
          wholeSubject={wholeSubject}
          handleNext={this.handleNext}
          handleAddScore={this.handleAddScore}
          subjectScore={subjectScore}
          totalScore={totalScore}
        ></ToCollegeToolConditionScore>
        <ErrorTip
          visible={uiState.errorTipVisible}
          errorInfo={uiState.errorTip}
          handleCloseModal={this.handleCloseErrorTipModal}
        ></ErrorTip>
        <ToCollegeToolConditionConfirm
          subjectCondition={subjectCondition}
          close={this.handleCloseConfirm}
          visible={uiState.confirmVisible}
          wholeSubject={wholeSubject}
          time={uiState.time}
          handleConfirm={this.handleConfirm}
          subjectScore={subjectScore}
          totalScore={totalScore}
          times={times}
          release={release}
        ></ToCollegeToolConditionConfirm>
      </div>
    );
  }

  /**
   * 关闭条件确认框
   */
  handleCloseConfirm = () => {
    const { dispatch } = this.props;
    clearInterval(toCollegeSiv);
    dispatch(toCollegeToolActions.setTime(5));
    dispatch(toCollegeToolActions.setConfirmVisible(false));
  };

  /**
   * 确认分数
   */
  handleConfirm = () => {
    const { dispatch } = this.props;
    let time = this.props.uiState.time;
    if (time <= 0) {
      let params = {
        totalScore: this.props.totalScore,
        subjectCondition: this.props.subjectCondition,
        scoreCondition: this.props.scoreCondition,
      };
      post("/public/v1/toCollage/condition", params).then((res) => {
        dispatch(toCollegeToolActions.setConfirmVisible(false));
        this.props.history.push("/tocollege/major");
      });
    }
  };
  /**
   * 添加分数
   */
  handleAddScore = (e, subject) => {
    const { dispatch } = this.props;
    let score = e.target.value.replace(/\D/g, "");
    score = score === "" ? "" : parseInt(score.replace(/\D/g, ""), 0);
    let subjectScore = this.props.subjectScore;
    let maxScore = this.props.maxScore;
    if (subject === "总分") {
      dispatch(toCollegeToolActions.setTotalScore(score));
    } else {
      if (score > maxScore[subject]) {
        dispatch(toCollegeToolActions.setErrorTip(true, "成绩有误，请修改！"));
      } else {
        subjectScore[subject] = score;
        dispatch(toCollegeToolActions.setSubjectScore(subjectScore));
      }
    }
  };

  /**
   * 下一步操作
   */
  handleNext = () => {
    const { dispatch } = this.props;
    let subjectArray = this.props.subjectCondition;
    let subjectScore = this.props.subjectScore;
    let wholeSubject = this.props.wholeSubject;
    let totalScore = this.props.totalScore;
    if (subjectArray.length < 3) {
      dispatch(toCollegeToolActions.setErrorTip(true, "选考科目必选三项"));
    } else {
      let calTotal =
        subjectScore["语文"] +
        subjectScore["数学"] +
        subjectScore["外语"] +
        subjectScore[wholeSubject[subjectArray[0]]] +
        subjectScore[wholeSubject[subjectArray[1]]] +
        subjectScore[wholeSubject[subjectArray[2]]];
      if (calTotal !== totalScore) {
        dispatch(
          toCollegeToolActions.setErrorTip(true, "各科成绩与总分不符，请修改")
        );
      } else {
        if (this.judgeChange() === true) {
          // 首先判断一下该用户还有几次可以使用，如果没有次数可以用了 弹出没有次数的提示框
          get("/public/v1/toCollage/user/times").then((res) => {
            let data = res.data;
            dispatch(toCollegeToolActions.setTimes(data.times));
            dispatch(toCollegeToolActions.setRelease(data.isRelease));
            if (data.times > 0) {
              this.handleOpenConfirm();
              let scoreCondition = [
                { subject: "语文", score: subjectScore["语文"] },
                { subject: "数学", score: subjectScore["数学"] },
                { subject: "外语", score: subjectScore["外语"] },
                {
                  subject: wholeSubject[subjectArray[0]],
                  score: subjectScore[wholeSubject[subjectArray[0]]],
                },
                {
                  subject: wholeSubject[subjectArray[1]],
                  score: subjectScore[wholeSubject[subjectArray[1]]],
                },
                {
                  subject: wholeSubject[subjectArray[2]],
                  score: subjectScore[wholeSubject[subjectArray[2]]],
                },
              ];
              dispatch(toCollegeToolActions.setScoreCondition(scoreCondition));
            } else {
              dispatch(
                toCollegeToolActions.setErrorTip(
                  true,
                  "成绩已不能修改，可继续下一步操作"
                )
              );
              this.requestUserCondition();
            }
          });
        } else {
          this.props.history.push("/tocollege/major");
        }
      }
    }
  };

  /**
   * 判断分数是不是变了
   */
  judgeChange = () => {
    let subjectScore = this.props.subjectScore;
    let preSubjectScore = this.props.preSubjectScore;
    if (
      subjectScore["语文"] === preSubjectScore["语文"] &&
      subjectScore["数学"] === preSubjectScore["数学"] &&
      subjectScore["外语"] === preSubjectScore["外语"] &&
      subjectScore["政治"] === preSubjectScore["政治"] &&
      subjectScore["历史"] === preSubjectScore["历史"] &&
      subjectScore["地理"] === preSubjectScore["地理"] &&
      subjectScore["物理"] === preSubjectScore["物理"] &&
      subjectScore["化学"] === preSubjectScore["化学"] &&
      subjectScore["生物"] === preSubjectScore["生物"] &&
      subjectScore["技术"] === preSubjectScore["技术"]
    ) {
      return false;
    } else {
      return true;
    }
  };

  /**
   * 打开条件确认框
   */
  handleOpenConfirm = () => {
    const { dispatch } = this.props;
    dispatch(toCollegeToolActions.setConfirmVisible(true));
    dispatch(toCollegeToolActions.setTime(5));
    let time = 5;
    toCollegeSiv = setInterval(() => {
      time = --time;
      if (time <= -1) {
        clearInterval(toCollegeSiv);
      }
      dispatch(toCollegeToolActions.setTime(time <= -1 ? 0 : time));
    }, 1000);
  };

  /**
   * 请求用户条件
   */
  requestUserCondition = () => {
    const { dispatch } = this.props;
    get("/public/v1/toCollage/condition").then((res) => {
      let scoreCondition = JSON.parse(JSON.stringify(res.data.scoreCondition));
      let subjectCondition = JSON.parse(
        JSON.stringify(res.data.subjectCondition)
      );
      let totalScore = JSON.parse(JSON.stringify(res.data.totalScore));
      let subjectScore = this.props.subjectScore;
      for (let i = 0; i < scoreCondition.length; i++) {
        subjectScore[scoreCondition[i].subject] = scoreCondition[i].score;
      }
      let preSubjectScore = JSON.parse(JSON.stringify(subjectScore));
      dispatch(toCollegeToolActions.setScoreCondition(scoreCondition));
      dispatch(toCollegeToolActions.setPreSubjectScore(preSubjectScore));
      dispatch(toCollegeToolActions.setSubjectCondition(subjectCondition));
      dispatch(toCollegeToolActions.setTotalScore(totalScore));
    });
  };

  /**
   * 关闭错误提示框
   */
  handleCloseErrorTipModal = () => {
    const { dispatch } = this.props;
    if (
      this.props.uiState.errorTip ===
      "当前修改次数已用完，次年三位一体招生章程公布后可继续修改。"
    ) {
      dispatch(toCollegeToolActions.setErrorTip(false, ""));
    } else {
      dispatch(toCollegeToolActions.setErrorTip(false, ""));
    }
  };
  /**
   * 选择选考科目
   * @param {选考科目} subject
   */
  handleChooseSubject = (subject) => {
    const { dispatch } = this.props;
    let subjectArray = this.props.subjectCondition;
    let subjectScore = this.props.subjectScore;
    let wholeSubject = this.props.wholeSubject;
    if (
      this.handleSubjectErrorTip(subjectArray, subject) ||
      subjectArray.includes(subject)
    ) {
      if (subjectArray.includes(subject)) {
        subjectArray.splice(
          subjectArray.findIndex((item) => item === subject),
          1
        );
        subjectScore[wholeSubject[subject]] = "";
        dispatch(toCollegeToolActions.setSubjectScore(subjectScore));
      } else {
        subjectArray.push(subject);
      }
      dispatch(toCollegeToolActions.setSubjectCondition(subjectArray));
    }
  };
  /**
   * 控制错误的弹出框显示和关闭
   */
  handleSubjectErrorTip = (subjectArray, subject) => {
    const { dispatch } = this.props;
    if (subjectArray.length >= 3 && !subjectArray.includes(subject)) {
      dispatch(toCollegeToolActions.setErrorTip(true, "请先取消一科"));
      return false;
    }
    return true;
  };
  /**
   * 获取用户是否购买的标识
   */
  requestIsBuy = () => {
    get("/public/v1/user/isBuy").then((res) => {
      if (res.data === false) {
        jumpUrl("pay");
      }
    });
  };

  /**
   * 请求分享的配置
   */
  requestShareConfig = () => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: "浙考之家-每日高升-志愿智能助手", // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: "浙考之家-每日高升-志愿智能助手", // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };
}
const mapStateToProps = (state) => {
  return {
    subjectCondition: state.toCollageTool.toCollageData.subjectCondition,
    scoreCondition: state.toCollageTool.toCollageData.scoreCondition,
    uiState: state.toCollageTool.toCollageUIData,
    wholeSubject: state.toCollageTool.toCollageData.wholeSubject,
    subjectScore: state.toCollageTool.toCollageData.subjectScore,
    preSubjectScore: state.toCollageTool.toCollageData.preSubjectScore,
    totalScore: state.toCollageTool.toCollageData.totalScore,
    maxScore: state.toCollageTool.toCollageData.maxScore,
    times: state.toCollageTool.toCollageData.times,
    release: state.toCollageTool.toCollageData.release,
  };
};
export default connect(mapStateToProps)(ToCollegeToolCondition);



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolCondition/index.js